import { useEffect } from 'react';
import FilterCKAN from '../../lib/FilterCKAN';
import IconSelect from '../IconSelect';

export const FilterData = (filterData) => {
  let set = new Set();
  filterData.forEach((data) => {
    Object.entries(data).map(([, value]) => {
      set.add(value);
    });
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b));
};

const FilterCollection = (props) => {
  const {
    collectionNames,
    setCollectionNames,
    pillar,
    setPillar,
    element,
    setElement,
    collectionsList,
    setCollectionList,
    pillarList,
    setPillarList,
    elementList,
    setElementList,
    handleFilterChange,
    setErrorMessage,
  } = props;

  useEffect(() => {
    const fetchCollectionsData = async () => {
      if (!collectionsList) {
        const fetchData = await FilterCKAN.getCollectionData();
        if (
          fetchData?.data?.result?.results == undefined ||
          fetchData?.length == 0
        ) {
          setErrorMessage(fetchData?.message);
        } else {
          let collectionArray = FilterData(fetchData.data.result.results);
          setCollectionList(collectionArray);
        }
      }
    };
    fetchCollectionsData();
  }, []);
  const handlePillarList = async (selectedCollection) => {
    const fetchData = await FilterCKAN.getPillarData(selectedCollection);
    if (fetchData) {
      let pillarArray = FilterData(fetchData);
      if (pillarArray.length === 0) {
        setPillarList(null);
      } else {
        setPillarList(pillarArray);
      }
    }
  };
  const handleElementList = async (selectedPillar) => {
    const fetchData = await FilterCKAN.getElementData(
      collectionNames,
      selectedPillar
    );
    if (fetchData) {
      let elementArray = FilterData(fetchData);
      if (elementArray.length === 0) {
        setElementList(null);
      } else {
        setElementList(elementArray);
      }
    }
  };

  return (
    <>
      {/* Sits inline in the search row, between the search box and buttons. */}
      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
          <IconSelect
            title={'Filter By Collections'}
            value={collectionNames}
            list={collectionsList}
            hasIcons={false}
            disabled={collectionsList == null}
            onClick={(e) => {
              handleFilterChange(e, '', '');
              setCollectionNames(e);
              handlePillarList(e);
              setPillar('');
              setElement('');
              setElementList(null);
            }}
          ></IconSelect>

          {pillarList && (
            <div>
              <IconSelect
                title={'Pillars and Sub Collections'}
                value={pillar}
                list={pillarList}
                hasIcons={true}
                onClick={(e) => {
                  handleFilterChange(collectionNames, e, '');
                  setPillar(e);
                  handleElementList(e);
                  setElement('');
                }}
              ></IconSelect>
            </div>
          )}
          {elementList && (
            <div>
              <IconSelect
                title={'Elements'}
                value={element}
                list={elementList}
                hasIcons={false}
                onClick={(e) => {
                  handleFilterChange(collectionNames, pillar, e);
                  setElement(e);
                }}
              ></IconSelect>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default FilterCollection;
